import React, { FC, ReactElement } from "react"
import { useFormikContext } from "formik"

import { TenantConfigData } from "../../../types/api"
import { InputField } from "../../inputs/InputField"
import { TitledCheckbox } from "../../inputs/TitledCheckbox"

export const RegularFields: FC = (): ReactElement => {
  const { values, handleChange } = useFormikContext<TenantConfigData>()
  return (
    <div className="my-10">
      <InputField name="sealANJText" value={values.sealANJText} onChange={handleChange} title="Seal ANJ Text" />
      <InputField name="noSealText" value={values.noSealText} onChange={handleChange} title="No Seal Text" />
      <div className="flex my-5 flex-row gap-10">
        <div className="w-[8%]">
          <TitledCheckbox id="isDisableFiat" title="Disable FIAT" checked={values.isDisableFiat} onChange={handleChange} />
        </div>
        <div className="w-[10%]">
          <TitledCheckbox id="isDisableCrypto" title="Disable crypto" checked={values.isDisableCrypto} onChange={handleChange} />
        </div>
        <div className="w-[15%]">
          <TitledCheckbox
            id="isPhoneVerificationEnabled"
            title="Enable Phone Verification"
            checked={values.isPhoneVerificationEnabled}
            onChange={handleChange}
          />
        </div>
      </div>
    </div>
  )
}
